module.exports = __webpack_public_path__ + "img/havard.91eb4969.jpg";